import type {OFFER_LETTER, JOB_INFORMATION} from 'src/types/crm';
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {useHistory} from 'src/rerouter';

import {useApi} from 'src/hooks/useApi';

import {useDispatch, useSelector} from 'react-redux';
import * as reduxApi from 'src/utils/redux-api-v2';

import {
  selectPendingOfferCandidateDetails,
  selectJobInformation,
} from 'src/selectors/crm';
import {
  SubTitleLarge,
  BodyMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {TabList, Tab} from '@spaced-out/ui-design-system/lib/components/Tabs';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';
import User from 'src/components/crm/lib/user/user';
import {formatMomentDateAndTime} from 'src/utils/date-time';
import {
  size200,
  size180,
  size100,
} from '@spaced-out/ui-design-system/lib/styles/variables/_size';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';

import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@spaced-out/ui-design-system/lib/components/Modal';
import {
  Toast,
  TOAST_SEMANTIC,
  ToastTitle,
  toastApi,
} from '@spaced-out/ui-design-system/lib/components/Toast';
import {
  Panel,
  PanelBody,
  PanelHeader,
  PanelFooter,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {BasicDetails} from './tabs/basic-details';
import {CandidateResume} from './tabs/candidate-resume';
import {ApprovalStatus} from '../../approve-job/approve-job-form/tabs/approval-status';

import {UPDATE_SELECTED_PENDING_OFFER_CANDIDATE} from 'src/utils/crm';

import css from './approve-offer-form.css';
import {JobDetailsTab} from 'src/components/crm/lib/job-details-tab/job-details-tab';
import CandidateDetailsCard from 'src/components/crm/jobs/job-info/overview/feedbacks/panels/candidate-details-card/candidate-details';
import {
  getJobInformation,
  getApplicantInformation,
  getInterviewFlow,
  getJobScoreCards,
} from 'src/action-creators/crm';
import FeedbackAndScorecard from 'src/components/crm/applicants/body/tabComponents/feedback-and-scorecards/index';
import ApplicantAttachments from 'src/components/crm/applicants/body/tabComponents/attachments/index';
import CandidateFormsSubmitted from 'src/components/crm/applicants/body/tabComponents/forms/candidate-forms-submitted';
import {JobDescription} from 'src/components/crm/lib/job-description/job-description';


export const ApproveOfferForm = ({
  isOpen,
  handleClose,
  handleMoveBack,
  currentJobId,
  isRejected = false,
  isApproved = false,
  onSubmit,
}: {
  isOpen: boolean;
  handleClose: (queryObject?: {readonly [key: string]: string}) => void;
  handleMoveBack: (refetch: boolean) => void;
  currentJobId?: string;
  isRejected?: boolean;
  isApproved?: boolean;
  onSubmit?: () => void;
}) => {
  const {t, language} = useLabelTranslation();
  const selectedCandidate = useSelector(selectPendingOfferCandidateDetails);
  const [refetchApplicantData, setRefetchApplicantData] = React.useState(false);
  const history = useHistory();
  const {location} = history;
  const dispatch = useDispatch();
  const {candidateId, stageId} = selectedCandidate ?? {};
  const jobInfo = useSelector(selectJobInformation);

  const {parent} = location.query;
  const jobId = location.query.jobId || currentJobId || '';

  const fetchApplicantData = async () => {
    try {
      if (jobId) {
        await Promise.all([
          dispatch(getApplicantInformation(candidateId, jobId)),
          dispatch(getInterviewFlow(jobId.toString(), candidateId.toString())),
          dispatch(getJobScoreCards(Number(jobId))),
        ]);
      } else {
        await Promise.all([dispatch(getApplicantInformation(candidateId))]);
      }
    } finally {
    }
  };

  React.useEffect(() => {
    fetchApplicantData();
  }, [refetchApplicantData]);

  React.useEffect(() => {
    dispatch(getJobInformation(jobId));
  }, [jobId]);
  const [offerDetails, setOfferDetails] = React.useState<OFFER_LETTER | null>(
    null,
  );
  const [currentApprovalObject, setCurrentApprovalObject] =
    React.useState<any>(null);
  const [selectedOption, setSelectedTabOption] = React.useState({
    label: t('Offer_Details', 'Offer Details'),
    tabId: 'offer',
  });
  const [actionModalState, setActionModalState] = React.useState<
    'approve' | 'reject' | null
  >(null);
  const [offerApprovalMessage, setOfferApprovalMessage] = React.useState('');
  const [approvingOffer, setApprovingOffer] = React.useState(false);
  const [isLoadingData, setisLoadingData] = React.useState(false);
  const [candidateDetails, setCandidateDetails] = React.useState<any>(null);
  const [jobDetails, setJobDetails] = React.useState<JOB_INFORMATION | null>(
    null,
  );
  const closePanelHandler = () => {
    handleClose();
  };

  const getTabComponent = () => {
    if (!offerDetails || !candidateDetails || !jobDetails) {
      return null;
    }
    if (selectedOption.tabId === 'offer') {
      return (
        <BasicDetails
          offerDetails={offerDetails}
          isApproved={isApproved}
          isRejected={isRejected}
          currentApprovalObject={currentApprovalObject}
        />
      );
    } else if (selectedOption.tabId === 'approvalStatus') {
      return (
        // @ts-expect-error - TS2741 - Property 'type' is missing in type '{ approvalObject: OFFER_LETTER; approverStatusesList: { id: number; createdBy: number; createdOn: number; updatedBy: number; updatedOn: number; comment?: string | undefined; ... 10 more ...; new: boolean; }[]; }' but required in type '{ approvalObject: any; approverStatusesList: any; type: any; viewOnly?: boolean | undefined; }'.
        <ApprovalStatus
          approvalObject={offerDetails}
          approverStatusesList={offerDetails.approverStatuses}
        />
      );
    } else if (selectedOption.tabId === 'resume') {
      return (
        <CandidateResume
          candidateName={candidateDetails.name}
          resumeLink={candidateDetails.resumeLink}
        />
      );
    } else if (selectedOption.tabId === 'jobDetails') {
      return <JobDetailsTab jobDetails={jobInfo} />;
    } else if (selectedOption.tabId === 'jobDescription') {
      return <JobDescription jobInfo={jobInfo} hideExternalJD={true} />;
    } else if (selectedOption.tabId === 'candidate') {
      return <CandidateDetailsCard candidateId={candidateId} jobId={jobId} />;
    } else if (selectedOption.tabId === 'feedback') {
      return (
        <FeedbackAndScorecard
          jobId={Number(jobId)}
          applicantId={candidateId}
          reloadCandidateData={() =>
            setRefetchApplicantData(!refetchApplicantData)
          }
          hideDownloadButton={true}
        />
      );
    } else if (selectedOption.tabId === 'attachments') {
      return (
        <ApplicantAttachments
          jobId={Number(jobId)}
          applicantId={candidateId}
          hideAttachmentsApplicationSpecificAttachments={true}
          showActionButtons={false}
        />
      );
    } else if (selectedOption.tabId === 'form') {
      return (
        <CandidateFormsSubmitted
          jobId={Number(jobId)}
          candidateId={candidateId}
          reloadCandidateData={() =>
            setRefetchApplicantData(!refetchApplicantData)
          }
          showActionButtons={false}
        />
      );
    }

    return selectedOption.label;
  };

  const {result: candidateOffer, isLoading: candidateOfferPending} = useApi(
    `api/offer-letter?candidateId=${candidateId}&jobId=${jobId}&stageId=${stageId}`,
    {
      method: 'GET',
      shouldFetch: !!jobId && !!candidateId,
      deps: [jobId],
      apiPath: '/trmapi/',
    },
  );

  const {result: userDetails, isLoading: userDetailsLoading} = useApi(
    `api/get-user-profile`,
    {
      method: 'GET',
      shouldFetch: !!jobId,
      deps: [jobId],
      apiPath: '/trmapi/',
    },
  );

  React.useEffect(() => {
    // @ts-expect-error - TS2339 - Property 'length' does not exist on type '{}'.
    if (candidateOffer && userDetails && candidateOffer.length) {
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'. | TS2339 - Property 'length' does not exist on type '{}'.
      const offer = candidateOffer[candidateOffer.length - 1];
      setOfferDetails(offer);
      console.log('offerrrr', offer, userDetails);
      setCurrentApprovalObject(
        offer.approverStatuses.find(
          // @ts-expect-error - TS7006 - Parameter 'app' implicitly has an 'any' type.
          (app) =>
            // @ts-expect-error - TS2339 - Property 'securityUserId' does not exist on type '{}'.
            app.approverId === userDetails?.securityUserId &&
            app.approvalRequestId === offer.offerLetterApprovalRequest.id,
        ),
      );
    }
  }, [candidateOffer, userDetails]);

  console.log('currentApprovalObject', currentApprovalObject);

  const handleApproveOfferLetter = async (
    payload: {
      comment: string;
      status: string;
    },
    messages: {
      errorMessage: string;
      successMessage: string;
    },
  ) => {
    setApprovingOffer(true);
    await dispatch(
      reduxApi.post(
        `api/offer-letter-approval-statuses/${currentApprovalObject?.id ?? 0}`,
        payload,
        {},
        {apiPath: '/trmapi/'},
      ),
    )
      .then(() => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.success}>
            <ToastTitle>{messages.successMessage}</ToastTitle>
          </Toast>,
          {
            timeout: 2000,
          },
        );
        dispatch({
          //@ts-expect-error
          type: UPDATE_SELECTED_PENDING_OFFER_CANDIDATE,
          //@ts-expect-error
          payload: null,
        });
        if (onSubmit) {
          onSubmit();
        }
        handleClose({
          taskType: parent,
          jobId: jobId ? jobId.toString() : '',
          refetch: 'true',
        });
      })
      .catch(() => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>{messages.errorMessage}</ToastTitle>
          </Toast>,
          {
            timeout: 2000,
          },
        );
      })
      .finally(() => {
        setApprovingOffer(false);
      });
  };

  React.useEffect(() => {
    if (!selectedCandidate) {
      handleMoveBack(true);
    }
  }, [selectedCandidate]);

  React.useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        if (offerDetails && offerDetails.candidateId) {
          setisLoadingData(true);
          const [jobDetail, candidateDetail] = await Promise.all([
            dispatch(
              reduxApi.get(`api/jobs/${jobId}`, {}, {apiPath: `/trmapi/`}),
            ),
            dispatch(
              reduxApi.get(
                `api/candidates/${offerDetails.candidateId}?include=applications&populateJobId=0`,
                {},
                {apiPath: '/trmapi/'},
              ),
            ),
          ]);
          setJobDetails(jobDetail);
          setCandidateDetails(candidateDetail);
        }
      } catch (e: any) {
        throw e;
      } finally {
        setisLoadingData(false);
      }
    };

    fetchJobDetails();
  }, [offerDetails]);

  const renderFooter = () => {
    if (isRejected || isApproved) {
      return null;
    }

    return (
      <PanelFooter>
        <div className={css.row}>
          <Button
            classNames={{wrapper: css.rejectButton}}
            onClick={() => setActionModalState('reject')}
          >
            {t('Reject', 'Reject')}
          </Button>

          <Button onClick={() => setActionModalState('approve')}>
            {t('Approve', 'Approve')}
          </Button>
        </div>
      </PanelFooter>
    );
  };

  const renderStatusAlert = () => {
    if (isRejected) {
      return (
        // @ts-expect-error TS2769
        <InContextAlert leftIconName="shield-exclamation" semantic="danger">
          {t('Rejected_by', 'Rejected by')}: {/* @ts-ignore */}
          <User userId={parseInt(currentApprovalObject?.approverId, 10)} />
          {`, ${t('on', 'on')}`}{' '}
          {formatMomentDateAndTime(currentApprovalObject?.updatedOn, language)}
        </InContextAlert>
      );
    }

    if (isApproved) {
      return (
        // @ts-expect-error TS2769
        <InContextAlert leftIconName="circle-check" semantic="success">
          {t('Approved_by', 'Approved by')}: {/* @ts-ignore */}
          <User userId={parseInt(currentApprovalObject?.approverId, 10)} />
          {`, ${t('on', 'on')}`}{' '}
          {formatMomentDateAndTime(currentApprovalObject?.updatedOn, language)}
        </InContextAlert>
      );
    }

    return (
      <div className={css.taskRow}>
        <Icon name="info-circle" color="secondary" />
        <BodyMedium color="secondary">
          {offerDetails
            ? `${t(
                'Offer_Approval_requested_on',
                'Offer Approval requested on',
              )}: ${new Date(offerDetails.updatedOn).toLocaleString(language)}`
            : null}
        </BodyMedium>
      </div>
    );
  };

  return (
    <Panel
      anchor="right"
      isOpen={isOpen}
      onClose={() => handleMoveBack(false)}
      size="large"
      tapOutsideToClose
      hideBackdrop={false}
    >
      <PanelHeader onCloseButtonClick={closePanelHandler} size="medium">
        <SubTitleLarge>
          {isRejected || isApproved
            ? t('Review_Offer_Approval', 'Review Offer Approval')
            : `${t('Approve_Offer', 'Approve Offer')} ${
                selectedCandidate
                  ? // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'OFFERS_CANDIDATE_INFO'.
                    `${t('for', 'for')} ${selectedCandidate.name}`
                  : ''
              }`}
        </SubTitleLarge>
      </PanelHeader>
      <PanelBody className={css.panelBody}>
        <div className={css.reviewWrapper}>
          {candidateOfferPending || userDetailsLoading || isLoadingData ? (
            <div className={css.loader}>
              <CircularLoader />
            </div>
          ) : (
            <>
              <div className={css.tabListWrapper}>
                <TabList
                  // @ts-expect-error - TS2769 - No overload matches this call.
                  onSelect={setSelectedTabOption}
                  selectedTab={selectedOption}
                  size="medium"
                >
                  <Tab
                    label={t('Offer_Details', 'Offer Details')}
                    tabId="offer"
                    maxWidth={size100}
                  />
                  <Tab
                    label={t('Candidate_Details', 'Candidate Details')}
                    tabId="candidate"
                    maxWidth={size180}
                  />
                  <Tab
                    label={t('Resume', 'Resume')}
                    tabId="resume"
                    maxWidth={size100}
                  />
                  <Tab
                    label={t('Feedback_Scorecard', 'Feedback & Scorecard')}
                    tabId="feedback"
                    maxWidth={size200}
                  />
                  <Tab
                    label={t('Job_Details', 'Job Details')}
                    tabId="jobDetails"
                  />
                  <Tab
                    label={t('Job_Description', 'Job Description')}
                    tabId="jobDescription"
                  />
                  <Tab label={t('Form', 'Form')} tabId="form" />
                  <Tab
                    label={t('Attachments', 'Attachments')}
                    tabId="attachments"
                  />
                  <Tab
                    label={t('Approval_Status', 'Approval Status')}
                    tabId="approvalStatus"
                  />
                </TabList>
              </div>
              {selectedOption.tabId === 'approvalStatus' && renderStatusAlert()}
              <div className={css.tabListComponent}>
                {offerDetails && userDetails ? getTabComponent() : null}
              </div>

              {actionModalState === 'approve' ? (
                <OfferApprovalCtaModal
                  title={t('Confirm_Approval', 'Confirm Approval')}
                  closeModal={() => {
                    setActionModalState(null);
                    setOfferApprovalMessage('');
                  }}
                  messageRequired={false}
                  message={offerApprovalMessage}
                  setMessage={setOfferApprovalMessage}
                  label={t('Add_comment_Optional', 'Add comment (Optional)')}
                  CtaButton={
                    <Button
                      onClick={() =>
                        handleApproveOfferLetter(
                          {
                            status: 'APPROVED',
                            comment: offerApprovalMessage,
                          },
                          {
                            successMessage: `${t(
                              'Offer_Approved_successfully',
                              'Offer Approved successfully',
                            )}!`,
                            errorMessage: `${t(
                              'Unable_to_approve_offer',
                              'Unable to approve offer',
                            )}`,
                          },
                        )
                      }
                      isLoading={approvingOffer}
                    >
                      {t('Approve', 'Approve')}
                    </Button>
                  }
                />
              ) : actionModalState === 'reject' ? (
                <OfferApprovalCtaModal
                  title={`${t('Reject_approval', 'Reject approval')}?`}
                  closeModal={() => {
                    setActionModalState(null);
                    setOfferApprovalMessage('');
                  }}
                  messageRequired={true}
                  message={offerApprovalMessage}
                  setMessage={setOfferApprovalMessage}
                  label={t('Add_Rejection_reason', 'Add Rejection reason')}
                  CtaButton={
                    <Button
                      classNames={{wrapper: css.rejectButton}}
                      onClick={() =>
                        handleApproveOfferLetter(
                          {
                            status: 'REJECTED',
                            comment: offerApprovalMessage,
                          },
                          {
                            successMessage: `${t(
                              'Offer_Rejected_successfully',
                              'Offer Rejected successfully',
                            )}!`,
                            errorMessage: `${t(
                              'Unable_to_reject_offer',
                              'Unable to reject offer',
                            )}`,
                          },
                        )
                      }
                      isLoading={approvingOffer}
                      disabled={!offerApprovalMessage}
                    >
                      {t('Reject', 'Reject')}
                    </Button>
                  }
                />
              ) : null}
            </>
          )}
        </div>
      </PanelBody>
      {renderFooter()}
    </Panel>
  );
};

const OfferApprovalCtaModal = ({
  // @ts-expect-error - TS7031 - Binding element 'title' implicitly has an 'any' type.
  title,
  // @ts-expect-error - TS7031 - Binding element 'closeModal' implicitly has an 'any' type.
  closeModal,
  // @ts-expect-error - TS7031 - Binding element 'messageRequired' implicitly has an 'any' type.
  messageRequired,
  // @ts-expect-error - TS7031 - Binding element 'message' implicitly has an 'any' type.
  message,
  // @ts-expect-error - TS7031 - Binding element 'setMessage' implicitly has an 'any' type.
  setMessage,
  // @ts-expect-error - TS7031 - Binding element 'CtaButton' implicitly has an 'any' type.
  CtaButton,
  // @ts-expect-error - TS7031 - Binding element 'label' implicitly has an 'any' type.
  label,
}) => {
  const {t} = useLabelTranslation();
  return (
    <Modal
      initialFocus={1}
      onClose={closeModal}
      isOpen
      classNames={{content: css.modalContent}}
    >
      <ModalHeader onCloseButtonClick={closeModal}>
        <SubTitleLarge>{title}</SubTitleLarge>
      </ModalHeader>
      <ModalBody>
        <Textarea
          label={label}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required={messageRequired}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal} type="ghost">
          {t('Close', 'Close')}
        </Button>
        {CtaButton}
      </ModalFooter>
    </Modal>
  );
};
